const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const trackEvent = async (eventType, metadata = {}) => {
  try {
    console.log(`[Analytics] ${eventType}`, metadata);
    await fetch(`${API}/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_type: eventType, metadata })
    });
  } catch (e) {
    console.warn('Analytics tracking failed:', e);
  }
};

export const EVENTS = {
  VIEW_PRODUCT: 'view_product',
  ADD_TO_QUOTE_CART: 'add_to_quote_cart',
  VIEW_CART: 'view_cart',
  START_QUOTE: 'start_quote',
  SUBMIT_QUOTE: 'submit_quote',
  START_RFQ: 'start_rfq',
  SUBMIT_RFQ: 'submit_rfq',
  START_CHECKOUT: 'start_checkout',
  PURCHASE_COMPLETED: 'purchase_completed',
  OPEN_CALCULATOR: 'open_calculator',
  CALCULATE_SAVINGS: 'calculate_savings',
  VIEW_CASE_STUDY: 'view_case_study',
  CLICK_CTA: 'click_cta',
};
